import settings from '@solinkcorp/settings';

export class PublicApi {
  async getAlarmEvent(id: string) {
    const url = `${settings.publicAlarmHost}/alarm/${id}?action=json`;
    try {
      const response = await fetch(url);
      return await response.json();
    } catch (err) {
      return { err };
    }
  }
}

export default new PublicApi();
